import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchEnviro } from "../services";

export const fetchEnviroData = createAsyncThunk(
  "enviro/fetchEnviroData",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchEnviro();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const enviroSlice = createSlice({
  name: "enviro",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnviroData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEnviroData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchEnviroData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default enviroSlice.reducer;
